import { defineComponent, PropType } from 'vue';

import './hidden-file-selector.scss';

const CN = 'hidden-file-selector';

export default defineComponent({
  props: {
    accept: { type: String, required: true },

    onFileSelected: { type: Function as PropType<(file: File) => void>, required: true },
  },

  emits: {
    'file-selected': (file: File) => file instanceof File,
  },

  setup(props) {
    const handleChangeEvent = (ev: Event) => {
      if (!(ev.target instanceof HTMLInputElement)) {
        return;
      }

      const file = ev.target.files?.item(0);

      if (file) {
        props.onFileSelected(file);
      }
    };

    return () => (
      <input
        accept={props.accept}
        aria-hidden={true}
        class={CN}
        data-testid="hidden-file-input"
        name="file"
        type="file"
        onChange={handleChangeEvent}
      />
    );
  },
}) as any;
